/**
 * @public
 * Builds the URL query parameters from an object.
 * It uses `encodeURIComponent` to set each value.
 *
 * @param  {Object} obj: the object to convert as URL query parameters
 * @return {String}
 */
export default function toUrlParams(obj) {
  let value;
  if (!obj) return '';
  const query = Object.keys(obj).reduce((params, key) => {
    value = obj[key];
    if (typeof value === 'function') return params;
    if (typeof value === 'object') value = JSON.stringify(value);
    params.push(`${key}=${encodeURIComponent(value)}`);
    return params;
  }, []).join('&');
  return `?${query}`;
}
